import { Box, ColorOptions, ModBox, Spacer, Text, TextInput } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { InteractionManager, Keyboard, TextInput as RNTextInput } from 'react-native'
import { SvgImage } from '../../../comps/SvgImage'
import { testProps } from '../../../util/util'
import styles from './styles'
import { TextInputProps } from './types'

interface Props extends TextInputProps {
  inputType?: 'box' | 'bottomline'
  onAutoOTPFilled?: any
}
const CODE_LENGTH = new Array(6).fill(0)

const OtpTextInput: FC<Props> = ({
  inputType = 'bottomline',
  fieldName,
  setFieldValue,
  value = '',
  onAutoOTPFilled,
  ...props
}: Props) => {
  const isFocused = useIsFocused()

  const otpInputRef = useRef<RNTextInput>(null)

  const [focused, setFocused] = useState(true)
  // const [keyboardHeight] = useKeyboard()

  const handleFocus = () => {
    setFocused(true)
  }
  const handleBlur = () => {
    setFocused(false)
    Keyboard.dismiss()
    if (props?.onBlur) {
      props.onBlur()
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => setFieldValue(fieldName, ''), [])

  useEffect(() => {
    // Must run after animations for keyboard to automatically open
    if (isFocused) {
      InteractionManager.runAfterInteractions(() => {
        if (otpInputRef?.current) {
          // 'focus input'
          otpInputRef?.current?.focus()
        }
      })
      // if (keyboardHeight === 0) {
      //   if (otpInputRef?.current) {
      //     otpInputRef?.current?.blur()
      //   }
      // }
    }
  }, [isFocused])

  const setOtpValue = useCallback((otp) => setFieldValue(fieldName, otp), [fieldName, setFieldValue])

  const handleKeyPress = (e: any) => {
    if (e.nativeEvent.key === 'Backspace') {
      handleFocus()
      if (setFieldValue && fieldName) {
        setFieldValue(fieldName, value.slice(0, value.length - 1))
      }
    }
  }
  const handleChange = (text: string) => {
    if (value.length < CODE_LENGTH.length) {
      // handleFocus()
      if (value.length === CODE_LENGTH.length - 1) {
        handleBlur()
      }
      if (setFieldValue && fieldName) {
        setFieldValue(fieldName, value + text)
      }
    }
  }
  const isError = props.error && !focused && value?.length < 6
  const values = value?.split('') ?? []

  const textBox = CODE_LENGTH.map((v, index) => {
    const selected = values.length === index
    const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1
    const getTextView = () => {
      if (!values[index]) {
        return (
          <Text fontFamily={'JioType-Medium'} fontSize={24} type={'h2'}>
            {''}
          </Text>
        )
      }
      return (
        <Text fontFamily={'JioType-Medium'} fontSize={24} type={'h2'}>
          {values[index]}
        </Text>
      )
    }
    const highlightBottom = (selected || filled) && focused
    const errorStyle = isError ? styles.error(highlightBottom, inputType, index) : {}

    const content = getTextView()
    return (
      <Box
        {...styles.display(highlightBottom, inputType, index)}
        {...errorStyle}
        key={index}
        underlayColor="TRANSPARENT">
        {content}
      </Box>
    )
  })

  const focusInput = () => {
    setFocused(true)
    otpInputRef?.current?.focus()
  }
  return (
    <Box
      {...styles.container}
      {...testProps('pin-outer-box')}
      onPress={focusInput}
      underlayColor="TRANSPARENT"
      testID={props?.testID}>
      <Box {...styles.subContainer} {...testProps('pin-input-box')}>
        <Box {...styles.wrap} {...testProps('pin-inner-box')} underlayColor="TRANSPARENT">
          <Box {...styles.input}>
            <TextInput
              testID="pin-input"
              accessibilityLabel="pin-input"
              nativeID="pin-input"
              value=""
              caretHidden={false}
              {...styles.input}
              onChangeText={handleChange}
              onKeyPress={handleKeyPress}
              onFocus={handleFocus}
              onBlur={() => handleBlur()}
              autoFocus={true}
              inputMode="numeric"
              onFocusBottomLineColor={'TRANSPARENT'}
              showBottomLine={false}
              maxLength={6}
              innerRef={otpInputRef}
              returnKeyType={value?.length > 5 ? 'done' : 'next'}
            />
          </Box>
          {textBox}
        </Box>
        <Spacer size={10} direction="horizontal" />
        {props.rightView}
      </Box>
      {isError && (
        <ModBox w={'100%'} mt={30} flexDirection="row">
          <SvgImage imageName="WarningIconError" color={'#E30513'} />
          {/* <Icon id={'INFO'} color={'#E30513' as ColorOptions} size={16} /> */}
          <Spacer size={4} direction="horizontal" />
          <Text type={'caption'} textAlign="left" color={'#E30513' as ColorOptions} numberOfLines={1}>
            {props.error}
          </Text>
        </ModBox>
      )}
    </Box>
  )
}

export { OtpTextInput }
